import { useState, useEffect } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Avatar,
  InputAdornment,
  Divider,
} from "@mui/material";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import PinRoundedIcon from "@mui/icons-material/PinRounded";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { endPoints } from "../../constant/Environment";
import { Actions } from "../../redux/Actions/Actions";
import { addData } from "../../Utility/API";
import Toaster from "../../components/Toast";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import Loader from "../../components/Loader";
import { tokens } from "../../theme";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loginData = location.state?.loginData;

  useEffect(() => {
    if (loginData?.message) {
      SuccesToast(loginData.message);
    }
  }, [loginData]);

  // No login response in navigation state → go back to login.
  if (!loginData) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!otp) {
      ErrorToast("Please enter OTP.");
      return;
    }

    const url = `${endPoints.api.VERIFY_USER_OTP}`;
    setIsLoading(true);

    const data = {
      idUser: loginData.data.idUser,
      login: loginData.data.login,
      login_otp: otp,
      token: loginData.data.token,
    };

    await addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          const userloginData = response.data;
          sessionStorage.setItem("user", JSON.stringify(userloginData));
          sessionStorage.setItem(
            "session",
            JSON.stringify(userloginData.data.sessionId)
          );
          dispatch({ type: Actions.LOGIN, data: { user: userloginData } });
          navigate("/Home");
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        ErrorToast("OTP verification failed. Please try again.");
        console.error(error);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Toaster />
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          p: { xs: 3, sm: 4.5 },
          borderRadius: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              width: 56,
              height: 56,
              mb: 1.5,
              borderRadius: "14px",
              background: `linear-gradient(135deg, ${tokens.primary}, #5B3FB0)`,
              boxShadow: "0 10px 30px rgba(139,109,240,0.5)",
            }}
          >
            <ShieldRoundedIcon fontSize="large" />
          </Avatar>
          <Typography variant="h5">Verify OTP</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", mt: 0.5 }}>
            Enter the one-time code sent to
            {loginData?.data?.login ? ` ${loginData.data.login}` : " your registered contact"}
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            label="One-time code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            autoFocus
            inputProps={{ inputMode: "numeric", autoComplete: "one-time-code" }}
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinRoundedIcon fontSize="small" sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={isLoading}
            sx={{ mt: 3 }}
          >
            {isLoading ? "Verifying…" : "Verify"}
          </Button>

          <Button
            fullWidth
            color="inherit"
            onClick={() => navigate("/login")}
            sx={{ mt: 1.5 }}
          >
            Back to sign in
          </Button>

          <Divider sx={{ my: 2.5, borderColor: tokens.border }}>
            <Typography variant="caption" color="text.secondary">
              secured access
            </Typography>
          </Divider>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", textAlign: "center" }}
          >
            Two-factor authentication protects your admin account
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default VerifyOtp;
